<!-- <div [class.dark-theme]="darkLightSetting === 'light'" [class.light-theme]="darkLightSetting === 'light'"
     [class]="setTheme()"
     id="app-component"> -->
<div [class.light-theme]="true" [class]="setTheme()" id="app-component">
  <router-outlet></router-outlet>
</div>